import React from 'react';
import { Router, Link } from 'react-router-dom';
import {auth} from './firebase';
import './SignInUp.css';


class SignIn extends React.Component {

  constructor(props) {
    super(props);
    this.state = {email: '', password: ''};
    
    this.signInWithEmailAndPasswordHandler = this.signInWithEmailAndPasswordHandler.bind(this);
  }

  signInWithEmailAndPasswordHandler(event) {
    event.preventDefault();
    auth.signInWithEmailAndPassword(this.state.email, this.state.password).catch(error => {
      this.setState({error: "Error signing in with password and email!"});
      console.error("Error signing in with password and email", error);
    });

  }

  render() {
    


    return  <div className="App h-100 SignInUp">
              <div className="container-fluid h-100">
                <div className="row h-100">

                  

                  <div className="col-md-4 px-3 py-3 pb-md-4 text-left Tree">
                    
                        <div className="mt-8">
                          <h1 className="text-3xl mb-2 text-center font-bold">Sign In</h1>
                          <div className="border border-blue-400 mx-auto w-11/12 md:w-2/4 rounded py-8 px-4 md:px-8">
                            {this.state.error !== null && <div className = "py-4 bg-red-600 w-full text-white text-center mb-3">{this.state.error}</div>}
                            <form className="">
                              <label htmlFor="userEmail" className="block">
                                Email:
                              </label>
                              <input
                                type="email"
                                className="my-1 p-1 w-full"
                                name="userEmail"
                                value = {this.state.email}
                                placeholder="E.g: abc@gmail.com"
                                id="userEmail"
                                onChange = {event => this.setState({email: event.target.value})}
                              />
                              <br />
                              <label htmlFor="userPassword" className="block">
                                Password:
                              </label>
                              <input
                                type="password"
                                className="mt-1 mb-3 p-1 w-full"
                                name="userPassword"
                                value = {this.state.password}
                                placeholder="Your Password"
                                id="userPassword"
                                onChange = {event => this.setState({password: event.target.value})}
                              />
                              <button  onClick = {(event) => {this.signInWithEmailAndPasswordHandler(event)}}>
                                Sign in
                              </button>
                            </form>
                            <p className="text-center my-3">or</p>
                            
                            <p className="text-center my-3">
                              Don't have an account?{" "}
                              <Link to="signup" className="text-blue-500 hover:text-blue-600">
                                Sign up here
                              </Link>{" "}
                              <br />{" "}
                              <Link to = "passwordReset" className="text-blue-500 hover:text-blue-600">
                                Forgot Password?
                              </Link>
                            </p>
                          </div>
                        </div>




                  </div>  
                </div>
              </div>
            </div>
  }


}


export default SignIn;
